// Predictive search functionality
// This file is required by theme.liquid when predictive search is enabled.
console.log('Predictive search loaded');
